import { i as isPresent, f as formatI18nCurrency } from "./price-COKjAhbU.js";
import { i18n } from "@lingui/core";
const shorexSplitNewFeature = function () {
  let featureCodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const contentForActiveFeature = featureCodes.map(code => content.find(f => f && f.code === code)).filter(isPresent);
  const featureNew = contentForActiveFeature === null || contentForActiveFeature === void 0 ? void 0 : contentForActiveFeature.find(f => f.code === "new");
  const otherFeatures = contentForActiveFeature === null || contentForActiveFeature === void 0 ? void 0 : contentForActiveFeature.filter(f => f.code !== "new");
  return {
    featureNew,
    otherFeatures
  };
};
const formatShorexPrice = (price, priceType, i18n$1, currentCurrency) => {
  if (!isPresent(price) || price == 0) return void 0;
  const formattedPrice = formatI18nCurrency(price, "USD", i18n$1.locale, currentCurrency);
  const label = priceType === "per-vehicle" ? i18n._( /*i18n*/
  {
    id: "phWI9y",
    message: "Per vehicle"
  }) : i18n._( /*i18n*/
  {
    id: "bu1jgt",
    message: "Per guest"
  });
  return "".concat(formattedPrice, " ").concat(label);
};
export { formatShorexPrice as f, shorexSplitNewFeature as s };